import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Login = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'login' */
  './Login'
))

export function AsyncLogin(props: ComponentProps<any>) {
  return (
    <Suspense>
      <Login {...props} />
    </Suspense>
  )
}

export default AsyncLogin
